import { render, staticRenderFns } from "./NotificationsFilter.vue?vue&type=template&id=06bba956&"
import script from "./NotificationsFilter.vue?vue&type=script&lang=js&"
export * from "./NotificationsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports